<template>
  <div>
    <v-tabs :vertical="$vuetify.breakpoint.mdAndUp" show-arrows :grow="$vuetify.breakpoint.smAndDown" >
      <template v-for="(values, category, i) in lectures">
        <v-tab :key="category" class="justify-start">
          {{ category }}
        </v-tab>
        <v-tab-item :key="`${i}-item`">
          <my-lecture-card style="margin: 10px 0"
                           v-bind="lecture" v-for="(lecture, j) in values" :key="j"
                           @raise-error="raiseSnackbar"
          />
        </v-tab-item>
      </template>
    </v-tabs>
    <my-snackbar ref="snackbar"/>
  </div>

</template>

<script>
  // @ is an alias to /src

import {LECTURES} from "@/graphql/queries";
import MySnackbar from "@/components/mySnackbar";
import groupBy from "@/utils/groupBy";
import MyLectureCard from "@/components/myLectureCard";


export default {

  name: 'Lecture',
  components: {
    MyLectureCard,
    MySnackbar
  },

  data: () => ({
    show:false,
  }),


  apollo: {
    lectures: {
      query: LECTURES,
      error(error) {
       this.$refs.snackbar.raiseError(error.message)
      },
      update: data => groupBy(data.lectures, 'category')

    },
  },
  methods:{
    raiseSnackbar(message='', success=false){
      if(message.includes("You do not have permission")){
        this.$store.commit('LOGOUT_USER')
        this.$router.push('/')
      }
      else{
        if(success){
          this.snackbar.text = message;
          this.snackbar.color = "success"
        }
        else{
          this.snackbar.text = "Hata: " + JSON.stringify(message);
          this.snackbar.color = "error"
        }
        this.snackbar.show = true
      }
    },
  }

}
</script>
